import {PureComponent} from 'react'
import {Field, FieldArray, formValueSelector, reduxForm} from 'redux-form'
import HelpCircle from 'react-feather/dist/icons/help-circle.js'
import Tooltip from 'rc-tooltip'
import {connect} from 'react-redux'

import CityTypeahead from '../../Form/Field/CityTypeahead.jsx'
import CitiesTypeahead from '../../Form/Field/CitiesTypeahead.jsx'
import Contact from '../../Form/Field/Contact.jsx'
import Date from '../../Form/Field/Date.jsx'
import FormGlobalErrors from '../../Form/FormGlobalErrors.jsx'
import Input from '../../Form/Field/Input.jsx'
import Loader from '../../../../shared/components/Loader/Loader.jsx'
import Select from '../../Form/Field/Select.jsx'

import conf from '../../../conf.js'
import createOnSubmitFailHandler from '../../Form/createOnSubmitFailHandler.js'
import normBoolean from '../../Form/Normalizer/boolean.js'
import validate from './validate.js'

import './AdditionalInfoForm.scss'

export const name = 'AdditionalInfoForm'

class AdditionalInfoForm extends PureComponent {
  render() {
    return (
      <div id={name} className="additional-info-form">
        <form autoComplete="off" onSubmit={this.props.onSubmit}>
          <h4 className="text-center mt-5 mb-4">Identité</h4>
          <div className="row">
            <div className="col-md-6">
              <Field
                label="Prénom *"
                name="user.firstname"
                placeholder="John..."
                type="text"
                component={Input}
              />
            </div>
            <div className="col-md-6">
              <Field
                label="Nom *"
                name="user.lastname"
                placeholder="Doe..."
                type="text"
                required
                component={Input}
              />
            </div>
          </div>

          <h4 className="text-center mt-5 mb-4">Statut actuel</h4>
          <div className="row justify-content-center">
            <div className="col-md-6">
              <Field
                label="Autorisation de travail"
                name="freelance.work_permit"
                type="select"
                component={Select}
              >
                {Object.entries(conf.workPermits).map(([key, workPermit]) => (
                  <option value={workPermit.value} key={key}>{workPermit.label}</option>
                ))}
              </Field>
            </div>
            <div className="col-sm-12 col-xl-9">
              <Field
                label="Statut professionnel"
                name="freelance.situation"
                type="select"
                component={Select}
              >
                {Object.entries(conf.situations).map(([key, situation]) => (
                  <option value={situation.value} key={key}>{situation.label}</option>
                ))}
              </Field>
            </div>
          </div>

          <h4 className="text-center mt-5 mb-4">Disponibilité et durée de mission</h4>
          <div className="row">
            <div className="col-md-6">
              <Field
                label="Date de disponibilité *"
                name="freelance.date_available"
                placeholder="JJ/MM/AAAA"
                type="text"
                component={Date}
              />
            </div>
            <div className="col-md-6">
              <Field
                label="Commentaire"
                name="freelance.date_available_tunnel_comment"
                placeholder="disponible à temps partiel 2/5 jusqu’au JJ/MM/AAAA puis à temps complet"
                type="textarea"
                component={Input}
              />
            </div>
            <div className="col-md-6">
              <Field
                label="Format souhaité des missions"
                name="freelance.part_time"
                type="select"
                component={Select}>
                {Object.keys(conf.partTime).map((key) => {
                  const value = conf.partTime[key].value
                  return (
                    <option value={value} key={value}>
                      {conf.partTime[key].label}
                    </option>
                  )
                })}
              </Field>
            </div>
            {this.props.partTimeSelected ?
              <div className="col-md-6">
                <Field
                  label="Précisez le temps partiel souhaité"
                  name="freelance.part_time_comment"
                  type="textarea"
                  placeholder="3/5 idéalement, 4/5 maximum"
                  component={Input}
                />
              </div> : ''
            }
          </div>

          <h4 className="text-center mt-5 mb-4">Localisation et mobilité</h4>
          <div className="row">
            <div className="col-md-6">
              <Field
                label="Vous habitez la commune de *"
                name="user.city"
                placeholder="Paris, Bordeaux..."
                autocomplete="off"
                type="text"
                component={CityTypeahead}
              />
            </div>
            <div className="col-md-6">
              <Field
                label="Temps maximum de transport quotidien à temps plein"
                name="freelance.commute_time"
                type="textarea"
                placeholder="45mn en voiture, 1h10 en transport"
                component={Input}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <Field
                label="Je veux travailler dans la région de"
                name="user.work_cities"
                placeholder="Paris, Bordeaux..."
                autocomplete="off"
                type="text"
                component={CitiesTypeahead}
              />
            </div>
            <div className="col-md-12">
              <Field
                label="Je suis prêt à effectuer à plein temps une mission longue durée (3-6 mois par exemple) loin de chez moi"
                name="freelance.relocation_long_fulltime"
                type="checkbox"
                normalize={normBoolean}
                component={Input}
              />
            </div>
          </div>
          {this.props.relocationLongFullTimeAccepted ?
            <div className="row">
              <div className="col-md-12">
                <Field
                  label="Précisez si besoin"
                  name="freelance.relocation_long_fulltime_comment"
                  type="textarea"
                  placeholder="Max 3 mois"
                  component={Input}
                />
              </div>
            </div> : ''
          }

          <h4 className="text-center mt-5 mb-4">Positionnement</h4>
          <div className="row price-row">
            <div className="col-md-12 col-lg-6">
              <Field
                label={<span>
                  Taux journalier minimum en deçà duquel nous ne vous solliciterons pas. Ce TJ est indicatif et non communiqué.
                  <Tooltip
                    placement="top"
                    trigger={['hover', 'click', 'focus']}
                    overlay={
                      <span>
                        Vous aurez la capacité de prendre un positionnement différent sur chaque offre de mission
                      </span>
                    }
                  >
                    <HelpCircle size={20}/>
                  </Tooltip>
                </span>}
                name="freelance.price"
                type="number"
                component={Input}
              />
            </div>
            <div className="col-md-12 col-lg-6">
              <Field
                label="Si vous n’avez pas déterminé votre TJ, indiquez le montant équivalent en brut annuel que vous percevez/souhaitez percevoir"
                name="freelance.yearly_brut"
                type="number"
                component={Input}
              />
            </div>
          </div>

          <h4 className="text-center mt-5 mb-4">Validation des expériences (facultatif)</h4>
          <p className="text-center">
            Indiquez nous le(s) contact(s) pertinent(s) dans vos dernières expériences afin de valider vos expériences
          </p>
          <FieldArray
            name="freelance.references"
            btnLabel="Ajouter une référence"
            initialValues={{type: conf.contacts.reference}}
            label="référence"
            component={Contact}
          />

          <h4 className="text-center mt-5 mb-4">Contacts (facultatif)</h4>
          <p className="text-center">
            Connaissez vous des personnes susceptibles d'être intéressées par notre plateforme ?
          </p>
          <FieldArray
            name="user.prospects"
            btnLabel="Ajouter un contact"
            initialValues={{type: conf.contacts.prospect}}
            label="contact"
            component={Contact}
          />
          <input className="d-none" type="submit"/>
          <FormGlobalErrors className="mt-0" errors={this.props.error}/>
        </form>
        <Loader visible={this.props.submitting || this.props.triggerSubmit}>
          Sauvegarde en cours...
        </Loader>
      </div>
    )
  }
}

let ReduxAdditionalInfoForm = reduxForm({
  form: name,
  onSubmitFail: createOnSubmitFailHandler(name),
  validate
})(AdditionalInfoForm)

const selector = formValueSelector(name)

export default connect(
  state => ({
    partTimeSelected: parseInt(selector(state, 'freelance.part_time'),10) === conf.partTime.partTimeOnly.value,
    relocationLongFullTimeAccepted: selector(state, 'freelance.relocation_long_fulltime')
  })
)(ReduxAdditionalInfoForm)
